export const TERMINATION_TYPES = [
    {value: "personalTermination", label: "Şahsi Fesih"},
    {value: "employerTermination", label: "İşveren Feshi"}
];

export const EXIT_REASONS = [
    {value: "motorFailure", label: "Motor Arızası Sebebiyle"},
    {value: "positionTypeChange", label: "Pozisyon Tipi Değişikliği Nedeniyle"},
    {value: "payrollControl", label: "Puantaj Kontrolü"},
    {value: "competitorCompany", label: "Rakip Firmaya Geçiş"},
    {value: "health", label: "Sağlık Nedeniyle"},
    {value: "noReason", label: "Sebep Belirtmemiştir"},
    {value: "sectorChange", label: "Sektör Değişikliği"},
    {value: "familyPersonal", label: "Ailevi–Kişisel Sebepler"},
    {value: "dealerTransfer", label: "Bayi Devri"},
    {value: "betterWorkConditions", label: "Daha İyi Çalışma Koşulları"},
    {value: "education", label: "Eğitim Nedeniyle"},
    {value: "fraudReports", label: "Fraud Raporları"},
    {value: "employerTermination", label: "İşveren Feshi"}
];
